import { apiClient } from './api';

export interface Connection {
  id: string;
  platform: string;
  name: string;
  status: string;
  lastTested: string;
  endpoint?: string;
}

export interface CreateConnectionRequest {
  tenantId: string;
  platform: string;
  name: string;
  endpoint: string;
  apiKey: string;
}

export interface UpdateConnectionRequest {
  tenantId: string;
  endpoint: string;
  apiKey: string;
}

export const connectionService = {
  async getAllConnections(tenantId: string): Promise<Connection[]> {
    return apiClient.get<Connection[]>(`/connections?tenantId=${tenantId}`);
  },

  async createConnection(data: CreateConnectionRequest): Promise<Connection> {
    return apiClient.post<Connection>('/connections', data);
  },

  async updateConnection(id: string, data: UpdateConnectionRequest): Promise<Connection> {
    return apiClient.put<Connection>(`/connections/${id}`, data);
  },

  async deleteConnection(id: string): Promise<void> {
    return apiClient.delete<void>(`/connections/${id}`);
  },

  async testConnection(id: string): Promise<{ success: boolean }> {
    return apiClient.post<{ success: boolean }>(`/connections/${id}/test`);
  },
};
